export default ({ request }) => ({
  /**
   * 获取职位投递列表
   * @param params
   * @returns {*}
   * @constructor
   */
   POSITION_DELIVERY_LIST (params = {}) {
    // 接口请求
    return request({
      url: '/position/delivery/list',
      method: 'GET',
      params
    })
  },
  /**
   * 获取职位收藏列表
   * @param params
   * @returns {*}
   * @constructor
   */
   POSITION_COLLECTION_LIST (params = {}) {
    // 接口请求
    return request({
      url: '/position/collection/list',
      method: 'GET',
      params
    })
  }
})

